module.exports = __webpack_public_path__ + "static/media/Obstacle.d4d0bdda.png";